<template>
    <div class="shipping-table">
        <div class="mb-2">
            <div v-if="mode === 'read'">
                <b-button variant="outline-secondary" @click="print()">選択してラベル印刷</b-button>
                &nbsp;
                <b-button variant="outline-secondary" @click="print('invoice')">選択してインボイス印刷</b-button>
                <br>
                <small>個別ラベル印刷は発送サービス名をクリック</small>
                <div>
                    <small class="text-danger">※作成後30日を過ぎると印刷できなくなります。</small>
                </div>
            </div>
        </div>
        <div class="overflow-hidden" :style="'height: ' + styleHeight">
            <hot-table
                ref="hotTable"
                class="h-100"
                :mode="mode"
                :settings="hotSettings"
                @after-init="afterInit"
                @before-paste="beforePaste"
                />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import Handsontable from 'handsontable'
import AddressSearch from '@/components/AddressSearch.vue'
import TrackingCodeContent from '@/components/TrackingCodeContent.vue'
import VatContent from '@/components/VatContent.vue'
import ItemContent from '@/components/ItemContent.vue'
import BoxContent from '@/components/BoxContent.vue'
import ItemAttributeContent from '@/components/ItemAttributeContent.vue'
import CourierPlan from '@/components/CourierPlan.vue'
import moment from 'moment'
import { SHIPPING_TABLE } from '@/plugins/handsontable'

const FIELDS = SHIPPING_TABLE().FIELDS
const FIELDS_ALL = SHIPPING_TABLE().FIELDS_ALL
const data2JsonObject = SHIPPING_TABLE().METHODS.data2JsonObject

registerAllModules()

const getShippingItemPriceTotal = (instance, row) => {
    const obj = data2JsonObject([ instance.getDataAtRow(row) ])[0]

    if (!obj.shipping_item_price) {
        return null
    }

    let total = 0
    let prices = []
    let quantities = []
    prices = obj.shipping_item_price.split("\n").map((v) => {
        return parseInt(v)
    })
    quantities = obj.shipping_item_quantity.split("\n").map((v) => {
        return parseInt(v)
    })
    if (prices.length !== quantities.length) {
        FIELDS_ALL.forEach((v, i) => {
            if (v.name === 'shipping_item_price_total') {
                instance.setDataAtCell(row, i, '')
            }
        })
        return null
    }
    for (let i = 0; i < prices.length; i++) {
        total += prices[i] * quantities[i]
    }

    total = total + (1000 - total % 1000) % 1000

    return total
}
const calcShippingItemPriceTotal = (instance, row) => {
    const total = getShippingItemPriceTotal(instance, row)
    FIELDS_ALL.forEach((v, i) => {
        if (v.name === 'shipping_item_price_total') {
            const value_old = instance.getDataAtCell(row, i)
            if (value_old !== total) {
                instance.setDataAtCell(row, i, total)
            }
        }
    })
}
const getShippingBoxDimensionalWeight = (instance, row, scope) => {
    const obj = data2JsonObject([ instance.getDataAtRow(row) ])[0]

    if (!obj.shipping_box_depth
        || !obj.shipping_box_width
        || !obj.shipping_box_height
        ) {
        return null
    }

    return scope.dimensional_weight(
        obj.shipping_box_depth,
        obj.shipping_box_width,
        obj.shipping_box_height
    )
}
const calcShippingBoxDimensionalWeight = (instance, row, scope) => {
    const total = getShippingBoxDimensionalWeight(instance, row, scope)
    FIELDS_ALL.forEach((v, i) => {
        if (v.name === 'shipping_box_dimensional_weight') {
            const value_old = instance.getDataAtCell(row, i)
            if (value_old !== total) {
                instance.setDataAtCell(row, i, total)
            }
        }
    })
}
const clearShippingCourierPlan = (instance, row, scope) => {
    FIELDS_ALL.forEach((v, i) => {
        if (v.name === 'shipping_courier_plan') {
            instance.setDataAtCell(row, i, '')
        }
    })
}
const jsonObject2Data = (jsonObject) => {
    return jsonObject.map((v) => {
        return FIELDS_ALL.map((field) => {
            return field.load(v)
        })
    })
}
//const data2JsonObject = (data) => {
//    return data
//        .map((v) => {
//            let data = {}
//            for (let i = 0; i < FIELDS_ALL.length; i++) {
//                data[FIELDS_ALL[i].name] = FIELDS_ALL[i].get(v[i], v)
//            }
//            return data
//        })
//}
const urlValidator = (value, callback) => {
    let urls = value.split(',')
    if (urls.length !== 1) {
        callback(false)
    }
    return urlsValidator(value, callback)
}
const urlsValidator = (value, callback) => {
    if (value === null || value === '') {
        callback(true)
        return
    }
    let urls = value.split(',')
    for (let i = 0; i < urls.length; i++) {
        let url = urls[i]
        if (!isValidHttpUrl(url)) {
            callback(false)
            return
        }
    }
    callback(true)
}
const isValidHttpUrl = (string) => {
    let url
    try {
        url = new URL(string)
    } catch (_) {
        return false
    }
    return url.protocol === 'http:' || url.protocol === 'https:'
}

const app = {
    components: {
        HotTable,
        AddressSearch,
        VatContent,
        TrackingCodeContent,
        ItemContent,
        BoxContent,
        ItemAttributeContent,
        CourierPlan,
    },
    props: {
        mode: {
            type: String,
            required: true,
            default: 'read',
            // create, read, update
        },
        errors: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
        jsonKey: {
            type: String,
            required: false,
            default() {
                return null
            },
        },
        styleHeight: {
            type: String,
            required: false,
            default: 'calc(100vh - 25em)',
        },
    },
    watch: {
    },
    data() {
        return {
            hotRef: null,
            hotSettings: {
                readOnly: true,
                rowHeaders: true,
                colHeaders: true,
                licenseKey: 'non-commercial-and-evaluation',
                stretchH: 'all',
                contextMenu: false,
                width: '100%',
                allowInsertColumn: false,
                allowInsertRow: false,
                allowRemoveColumn: false,
                allowRemoveRow: false,
                outsideClickDeselects: false,
                selectionMode: 'range',

                autoRowSize : false,
                viewportColumnRenderingOffset: 70,

                colHeaders: FIELDS_ALL
                    .map((v) => { return v.colHeader })
                    ,
                columns: FIELDS_ALL
                    .map((v) => { return v.column })
                    ,
//                data: [],
                hiddenColumns: {
                    copyPasteEnabled: false,
                },
                colWidths: this.colWidths,

                // event
                afterInit() {
                    this.rootElement.__vue__.$emit('after-init')
                },
                afterGetColHeader: function(col, TH) {
                    TH.className = 'text-left align-bottom'
                },
                afterGetRowHeader: this.afterGetRowHeader,
                afterChange: this.afterChange,
                afterOnCellMouseDown: this.afterOnCellMouseDown,
                beforePaste (data, range) {
                    this.rootElement.__vue__.$emit('before-paste', data, range)
                },
                cells: this.cells,
            },
            modal: {
                courier_plans: {},
            },
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'auth_group',
            'trans',
            'shipping_address_default',
            'shipping_item_default',
            'shipping_default',
            'dimensional_weight',
            'create_shipping',
        ]),
    },
    async mounted() {
        window.$trans = this.trans
    },
    methods: {
        afterInit () {
            this.$watch('mode', (value_new, value_old) => {
                this.setup()
            }, {
                immediate: true, // オプション
            })
        },
        afterOnCellMouseDown (event, cell, el) {
//            let is_from_col = FIELDS.FROM
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
//            let is_to_col = FIELDS.TO
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
//            let is_importer_col = FIELDS.IMPORTER
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
//            let is_shipping_col = FIELDS.SHIPPING
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
//            let is_courier_col = FIELDS.COURIER
//                .map((v) => { return this.getColumnIndexByName(v.name) })
//                .includes(cell.col)
            let is_shipping_courier_plan_col = this.getColumnIndexByName('shipping_courier_plan') === cell.col

            if (! [ 'create', 'update', ].includes(this.mode)) {
                if (is_shipping_courier_plan_col) {
                    this.print()
                }
                return
            }
//
//            if (is_shipping_courier_plan_col) {
////            if (is_courier_col) {
//                this.$bvModal.show('modal-courier')
//            }
//
//            var now = new Date().getTime()
//            if(!(el.lastClick && now - el.lastClick < 1000)) {
//                el.lastClick = now
//                return
//            }
//
//            if (is_from_col) {
//                this.$bvModal.show('modal-from')
//            }
//            if (is_to_col) {
//                this.$bvModal.show('modal-to')
//            }
//            if (is_importer_col) {
//                this.$bvModal.show('modal-importer')
//            }
//            if (is_shipping_col) {
//                this.$bvModal.show('modal-shipping')
//            }
        },
        afterChange (changes, source) {
console.log('afterChange')
console.log(changes)
console.log(source)
            if (!changes) {
                return
            }

            let needs_calc_shipping_item_price_total = []
            let needs_calc_shipping_box_dimensional_weight = []
            let needs_clear_shipping_courier_plan = []
            for (let i = 0; i < changes.length; i++) {
                let row = changes[i][0]
                let col = changes[i][1]
                let column = FIELDS_ALL[col]

                switch (column.name) {
                    case 'shipping_item_quantity':
                    case 'shipping_item_price':
                        needs_calc_shipping_item_price_total.push(row)
                        break
                    case 'shipping_box_depth':
                    case 'shipping_box_width':
                    case 'shipping_box_height':
                        needs_calc_shipping_box_dimensional_weight.push(row)
                        break
                }
                if (column.name !== 'shipping_courier_plan') {
                    needs_clear_shipping_courier_plan.push(row)
                }
            }

            needs_calc_shipping_item_price_total = Array.from(new Set(needs_calc_shipping_item_price_total))
            needs_calc_shipping_box_dimensional_weight = Array.from(new Set(needs_calc_shipping_box_dimensional_weight))
            needs_clear_shipping_courier_plan = Array.from(new Set(needs_clear_shipping_courier_plan))
            if (needs_calc_shipping_item_price_total.length) {
                for (let i = 0; i < needs_calc_shipping_item_price_total.length; i++) {
                    calcShippingItemPriceTotal(this.$refs.hotTable.hotInstance, needs_calc_shipping_item_price_total[i])
                }
            }
            if (needs_calc_shipping_box_dimensional_weight.length) {
                for (let i = 0; i < needs_calc_shipping_box_dimensional_weight.length; i++) {
                    calcShippingBoxDimensionalWeight(this.$refs.hotTable.hotInstance, needs_calc_shipping_box_dimensional_weight[i], this)
                }
            }
            if (needs_clear_shipping_courier_plan.length) {
                for (let i = 0; i < needs_clear_shipping_courier_plan.length; i++) {
                    clearShippingCourierPlan(this.$refs.hotTable.hotInstance, needs_clear_shipping_courier_plan[i])
                }
            }
        },
        afterGetRowHeader (row, TH) {
            TH.className = 'text-left'
            const rowHeader = TH.querySelector('.rowHeader')
            rowHeader.innerHTML = ''
            switch (this.mode) {
                case 'create':
                    rowHeader.innerHTML = row + 1
                    break;
                case 'update':
                    rowHeader.innerHTML = row + 1
                    break;
                case 'read':
                default:
                    if (this.auth_level !== '300') {
                        break
                    }
                    const a = document.createElement('a')
                    a.innerText = '削除'
                    a.href = 'javascript:void(0)'
                    a.className = 'text-danger'
                    a.setAttribute('row', row)
                    a.addEventListener('click', this.onClickDelete)
                    rowHeader.appendChild(a)
                    break;
            }
        },
        async onClickDelete (event) {
console.log(event)
            let row = Math.trunc(event.target.getAttribute('row'))
            if (Number.isNaN(row)) {
                return
            }

            let data = this.getData()
            if (row >= data.length) {
                return
            }

            const result = await this.$utils.modalConfirm(
                this,
                'Tuskeyラベル削除の確認',
                'Tuskey保険データ、クーリエのシステム上のデータは削除されません。',
                {
                    okTitle: '削除する',
                    okVariant: 'danger',
                    cancelTitle: 'キャンセル',
                    cancelVariant: 'outline-secondary',
                }
            )
            if (!result) {
                return false
            }

//            this.$emit('destroy', data[row])
//
            this.$store
                .dispatch('shipping/destroy', { id: data[row].id, })
                .then((response) => {
                    console.log(response)
                    this.$emit('after-destroy', data[row])
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response.status === 404) {
                        this.$store.dispatch('notification/push', { color: 'danger', text: 'このデータは削除済みです。', life: 25, })
                    }
                })
console.log(data[row])
        },
        beforePaste (data, range) {
            if (this.mode !== 'create') {
                return
            }
            const startRow = range[0].startRow
            const count = this.$refs.hotTable.hotInstance.countRows()
            
            for (let i = 0; i < data.length + startRow - count; i++) {
                this.$refs.hotTable.hotInstance.alter('insert_row')
            }
        },
        cells (row, column, prop) {
            let cell = null
            try {
                cell = this.$refs.hotTable.hotInstance.getCell(row, column)
            } catch (e) {}
            let cellProperties = {
                readOnly: this.hotSettings.readOnly,
            }
            if (FIELDS_ALL[column].readOnly) {
                cellProperties.readOnly = true
            }
            if (cell) {
//                if (cellProperties.readOnly) {
//                    cell.style.backgroundColor = "#dddddd"
//                } else {
//                    cell.style.backgroundColor = "inherit"
//                }
//                console.log(cell.style)
            }
            return cellProperties
        },
        setup () {
            let hidden_columns = []
            const column_index_user_id = this.getColumnIndexByName('user_id')
            if (column_index_user_id === -1) {
                return
            }
            switch (this.mode) {
                case 'create':
                    hidden_columns = []
                        .concat(FIELDS.SYSTEM)
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .concat(FIELDS.PROFILE)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = false
//                    this.hotSettings.selectionMode = 'range'
                    break
                case 'update':
                    hidden_columns = []
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .concat(FIELDS.PROFILE)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = false
//                    this.hotSettings.selectionMode = 'range'
                    break
                case 'read':
                default:
                    hidden_columns = []
                        .concat(FIELDS.SYSTEM_UPDATED_AT)
                        .concat(FIELDS.PROFILE)
                        .map((v) => { return this.getColumnIndexByName(v.name) })
                    this.hotSettings.readOnly = true
//                    this.hotSettings.selectionMode = 'multiple'
                    break
            }

            // user_id
            FIELDS_ALL[column_index_user_id].column.type = 'handsontable'
            FIELDS_ALL[column_index_user_id].column.renderer = (instance, td, row, col, prop, value, cellProperties) =>  {
                if (!value) {
                    td.innerText = ''
                    return td
                }
                td.innerText = value + ': '
                let text = '不明なユーザー'
                for (let i = 0; i < this.auth_group.length; i++) {
                    if ((value + '') === (this.auth_group[i].id + '')) {
                        text = this.auth_group[i].nickname
                        break
                    }
                }
                td.innerText += text
                return td
            }
            FIELDS_ALL[column_index_user_id].column.handsontable = {
                colHeaders: false,
                autoColumnSize: true,
                data: this.auth_group,
                getValue() {
                    const selection = this.getSelectedLast()
                    return this.getSourceDataAtRow(Math.max(selection[0], 0)).id
                },
            }
            this.$set(
                this.hotSettings,
                'columns',
                FIELDS_ALL.map((v) => { return v.column })
            )

            // filxed columns
//            this.hotSettings.fixedColumnsLeft = this.getColumnIndexByName('shipping_tracking_codes') + 1
            // updateSettings
            this.$refs.hotTable.hotInstance.updateSettings(this.hotSettings)

            // hidden columns
            let pluginHiddenColumns = this.$refs.hotTable.hotInstance.getPlugin('hiddenColumns')
            pluginHiddenColumns.hideColumns(hidden_columns)

            this.$refs.hotTable.hotInstance.render()
            this.$forceUpdate()
        },
        getColumnIndexByName(name) {
            let field_names =
                FIELDS_ALL
                .map((v) => { return v.name })
            return field_names.indexOf(name)
        },
        getVisibleColumns () {
            let pluginHiddenColumns = this.$refs.hotTable.hotInstance.getPlugin('hiddenColumns')
            let visibleColumns = []
            for (let i = 0; i < this.$refs.hotTable.hotInstance.getColHeader().length; i++) {
                if (pluginHiddenColumns.getHiddenColumns().indexOf(i) === -1) {
                    visibleColumns.push(i)
                }
            }
            return visibleColumns
        },
        getVisibleColumnFirst () {
            let cols = this.getVisibleColumns()
            return cols.length ? cols[0] : 0
        },
        loadData (hits) {
            this.deselectCell()
            this.$refs.hotTable.hotInstance.loadData(this.jsonObject2Data(hits))
            this.setup()
            this.$forceUpdate()
        },
        loadPartialData (hits) {
            let range = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (!range) {
                let visibleColumn = this.getVisibleColumnFirst()
                this.$refs.hotTable.hotInstance.selectCell(0, visibleColumn, 0, visibleColumn)
                range = this.$refs.hotTable.hotInstance.getSelectedRange()
            }
            range = range[0]

            hits = this.jsonObject2Data(hits)

            let changes = [];
            for (let row = range.from.row; row <= range.to.row; row++) {
                for (let col = 0; col <= hits[0].length; col++) {
                    if (typeof hits[0][col] === 'undefined') {
                        continue
                    }
                    changes.push([ row, col, hits[0][col], ])
                }
            }
            this.$refs.hotTable.hotInstance.setDataAtCell(changes)
        },
        getData () {
            return data2JsonObject(this.$refs.hotTable.hotInstance.getData())
        },
        getDataRanged (r) {
            let row = Number.NaN
            if (r === undefined) {
                let range = this.$refs.hotTable.hotInstance.getSelectedRange()
                if (!range) {
                    let visibleColumn = this.getVisibleColumnFirst()
                    this.$refs.hotTable.hotInstance.selectCell(0, visibleColumn, 0, visibleColumn)
                    range = this.$refs.hotTable.hotInstance.getSelectedRange()
                }
                range = range[0]
                row = range.from.row
            } else {
                row = r
            }
            if (Number.isNaN(row)) {
                return
            }

            let data = this.getData()
            if (row >= data.length) {
                return
            }

            return data[row]
        },
        jsonObject2Data (jsonObject) {
            return jsonObject2Data(jsonObject)
        },
//        data2JsonObject (data) {
//            return data2JsonObject(data)
//        },
        print (type = null) {
            let rows = []
            let ids = []
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (Array.isArray(ranges)) {
                for (let i = 0; i < ranges.length; i++) {
                    let row = ranges[i].from.row
                    rows = rows.concat([...Array(ranges[i].to.row - ranges[i].from.row + 1)].map((_, j) => j + ranges[i].from.row))
                }
                rows = Array.from(new Set(rows))
                for (let i = 0; i < rows.length; i++) {
                    let data = this.getDataRanged(rows[i])
                    ids.push(data.id)
                }
            }
            console.log(ids)
            this.$store
                .dispatch('shipping/print', {
                    ids: ids,
                    type: type,
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response.status === 404) {
                        this.$store.dispatch('notification/push', { color: 'danger', text: 'このデータは印刷できません。', life: 25, })
                    }
                })
        },
        addRow () {
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            let rowNew = 0
            if (!ranges) {
                this.$refs.hotTable.hotInstance.alter('insert_row_below')
                rowNew++
            } else {
                for (let i = ranges.length - 1; i >= 0; i--) {
                    this.$refs.hotTable.hotInstance.alter('insert_row_below', ranges[i].from.row + 0)
                    rowNew = ranges[i].from.row + 1
                }
            }
            let visibleColumn = this.getVisibleColumnFirst()
            this.$refs.hotTable.hotInstance.selectCell(rowNew, visibleColumn, rowNew, visibleColumn)

            this.loadPartialData([ this.shipping_default, ])
        },
        removeRow () {
            let ranges = this.$refs.hotTable.hotInstance.getSelectedRange()
            if (!ranges) {
                this.$refs.hotTable.hotInstance.alter('remove_row')
            } else {
                for (let i = ranges.length - 1; i >= 0; i--) {
                    const count = this.$refs.hotTable.hotInstance.countRows()
                    if (count <= ranges[i].from.row) {
                        continue
                    }
                    this.$refs.hotTable.hotInstance.alter('remove_row', ranges[i].from.row, ranges[i].to.row - ranges[i].from.row + 1)
                }
            }

            if (!this.$refs.hotTable.hotInstance.getData().length) {
                this.loadData([{}])
            }

            this.deselectCell()
        },
        deselectCell () {
            this.$refs.hotTable.hotInstance.deselectCell()
        },
        onSelectAddress ($event, prefix) {
            let options = {}
            options[prefix] = JSON.parse(JSON.stringify($event))
            let shipping = this.create_shipping(options)
            this.loadPartialData([ shipping, ])
            this.$bvModal.hide('modal-from')
            this.$bvModal.hide('modal-to')
            this.$bvModal.hide('modal-importer')
            this.$bvModal.hide('modal-courier')
            return
        },
        onShowModalFrom (event) {
        },
        onOkModalFrom (event) {
        },
        onShowModalTo (event) {
        },
        onOkModalTo (event) {
        },
        onShowModalImporter (event) {
        },
        onOkModalImporter (event) {
        },
        onShowModalShipping (event) {
            let row = this.getDataRanged()
            this.$utils.set(this.modal, {
                shipping_invoice_id: row.shipping_invoice_id,
                vat: this.normalizeVat(row),
                items: this.normalizeItems(row),
                boxes: this.normalizeBoxes(row),
                attributes: this.normalizeAttributes(row),
            })
console.log(this.modal)
        },
        onOkModalShipping (event) {
            let row = JSON.parse(JSON.stringify(this.modal))

            let attributes = []
            for (let [key, value] of Object.entries(row.attributes)) {
                if (value) {
                    attributes.push(key)
                }
            }

            this.$utils.set(row, {
                shipping_invoice_id: row.shipping_invoice_id,
                shipping_tax_target: row.vat.shipping_tax_target || null,
                shipping_tax_vat: row.vat.shipping_tax_target ? row.vat.shipping_tax_vat : null,
                shipping_tax_vat_issuer: row.vat.shipping_tax_target ? row.vat.shipping_tax_vat_issuer : null,
                shipping_item_quantity: row.items.map((v) => { return v.quantity || 1 }).join("\n"),
                shipping_item_hs_code: row.items.map((v) => { return v.hs_code }).join("\n"),
                shipping_item_country: row.items.map((v) => { return v.country }).join("\n"),
                shipping_item_name: row.items.map((v) => { return v.product }).join("\n"),
                shipping_item_price: row.items.map((v) => { return v.price }).join("\n"),

                shipping_box_depth: row.boxes.map((v) => { return v.depth }).join("\n"),
                shipping_box_width: row.boxes.map((v) => { return v.width }).join("\n"),
                shipping_box_height: row.boxes.map((v) => { return v.height }).join("\n"),
                shipping_box_weight: row.boxes.map((v) => { return v.weight }).join("\n"),

                shipping_item_attributes: attributes.join("\n"),
            })
            this.loadPartialData([ row, ]);
        },
        onShowModalCourier (event) {
            let row = this.getDataRanged()
            this.$utils.set(this.modal, row, {
                items: this.normalizeItems(row),
                boxes: this.normalizeBoxes(row),
                shipping_courier_plan: null,
            })
            this.$nextTick(() => {
                this.$refs.courierPlan.fetchRates()
            })
        },
        onSelectCourierPlan (courier, plan_name, plan_value) {
            this.$bvModal.hide('modal-courier')
            this.loadPartialData([ {
                // DHL
                shipping_courier_plan: {
                    courier: courier,
                    plan_name: plan_name,
                    plan_cost: plan_value.totalPrice[0].price,
                    plan_value: plan_value,
                }
            }, ]);
        },
        normalizeAddress (row, type) {
            let address = {}

            ;([
                'state',
                'zip',
                'country',
            ]).forEach((v, i) => {
                address[v] = row[type + '_' + v];
            })
            return address
        },
        normalizeVat (row) {
            return {
                shipping_tax_target: row.shipping_tax_target || null,
                shipping_tax_vat: row.shipping_tax_vat,
                shipping_tax_vat_issuer: row.shipping_tax_vat_issuer,
                from_country: row.from_country,
                to_country: row.to_country,
            }
        },
        normalizeItems (row) {
            let items = [];
            (row.shipping_item_quantity || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].quantity = v
            });
            (row.shipping_item_hs_code || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].hs_code = v
            });
            (row.shipping_item_country || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].country = v
            });
            (row.shipping_item_name || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].product = v
            });
            (row.shipping_item_price || '').split("\n").map((v, i) => {
                if (i >= items.length) {
                    items.push({})
                }
                items[i].price = v
            });
            return items
        },
        normalizeBoxes (row) {
            let boxes = [];
            (row.shipping_box_depth || '').split("\n").map((v, i) => {
                if (i >= boxes.length) {
                    boxes.push({})
                }
                boxes[i].depth = v
            });
            (row.shipping_box_width || '').split("\n").map((v, i) => {
                if (i >= boxes.length) {
                    boxes.push({})
                }
                boxes[i].width = v
            });
            (row.shipping_box_height || '').split("\n").map((v, i) => {
                if (i >= boxes.length) {
                    boxes.push({})
                }
                boxes[i].height = v
            });
            (row.shipping_box_weight || '').split("\n").map((v, i) => {
                if (i >= boxes.length) {
                    boxes.push({})
                }
                boxes[i].weight = v
            });
            return boxes
        },
        normalizeAttributes (row) {
            let attributes = {};
            (row.shipping_item_attributes || '').split("\n").map((v, i) => {
                if (v) {
                    attributes[v] = true
                }
            });
            return attributes
        },
        async uploadInsuranceCsv (event) {
console.log('uploadInsuranceCsv')
            const file = event?.target?.files[0]
console.log(file)
            const response = await this.$store
                .dispatch('insurance/upload_js', file)
console.log(response)
            event.target.value = null

            if (!response || response.length === 0) {
                alert('読込失敗')
                return
            }

            this.loadData(response)

            const index = this.getColumnIndexByName('shipping_item_price')
            this.afterChange(
                [ ...Array(response.length) ].map((v, i) => [ i, index, ])
            )
        },
        async downloadInsuranceCsv (event) {
            let data = {}

            // columns
            data.columns = this.getVisibleColumns()
                .filter((i) => {
                    return !FIELDS_ALL[i].readOnly
                })
                .map((i) => {
                    return FIELDS_ALL[i].name
                })

            // rows
            data.rows = [
                {
                    from_representative: 'Taro Yamada',
                    from_company: 'TY inc.',
                    from_address: '1-2-3, Azabudai, Minato-ku, Tokyo, 106-0041, Japan',
                    from_tel: '+818011112222',
                    from_email: 'taro@example.com',
                    to_representative: 'John Doe',
                    to_line1: '1500 NE Miami Pl',
                    to_line2: 'Apt 202',
                    to_city: 'Miami',
                    to_state: 'FL',
                    to_zip: '33132',
                    to_country: 'United States',
                    to_tel: '+16102347657',
                    to_email: 'john@example.com',
                    to_tax_id: '543210983',
                    shipping_courier: 'dhl',
                    shipping_invoice_id: '20230225example',
                    shipping_tracking_codes: 'CODE111111\nCODE222222222',
                    shipping_item_quantity: '1',
                    shipping_item_hs_code: '87087000',
                    shipping_item_country: 'Japan',
                    shipping_item_name: 'Used Wheels',
                    shipping_item_price: '40000',
                    shipping_label_issued_at: '2023-03-20',
                },
                {
                    from_representative: 'Hanako Tanaka',
                    from_company: 'HT LLC',
                    from_address: '9-8-7, Fujimidai, Koutou-ku, Tokyo, 123-4567, Japan',
                    from_tel: '+819011112222',
                    from_email: 'hanako@example.com',
                    to_representative: 'Karren Koe',
                    to_line1: '9999 NE Miami Pl',
                    to_line2: 'Apt 501',
                    to_city: 'Pomona',
                    to_state: 'CA',
                    to_zip: '98532',
                    to_country: 'United States',
                    to_tel: '+16444444444',
                    to_email: 'hanako@example.com',
                    to_tax_id: null,
                    shipping_courier: 'ups',
                    shipping_invoice_id: null,
                    shipping_tracking_codes: '123456789',
                    shipping_item_quantity: '5\n10',
                    shipping_item_hs_code: '87087000\n87087000',
                    shipping_item_country: 'Japan\nCanada',
                    shipping_item_name: 'New Wheels\nUsed Wheels',
                    shipping_item_price: '100000\n30000',
                    shipping_label_issued_at: null,
                },
            ]

            const response = await this.$store
                .dispatch('insurance/download_js', data)
console.log(response)

            if (!response || response.length === 0) {
                alert('CSV作成失敗')
                return
            }

            const blob = new Blob([response], { type: 'text/csv' })
            
            const anchor = document.createElement('a')
            anchor.href = window.URL.createObjectURL(blob)//'data:text/csv;charset=utf-8,' + encodeURIComponent(blob)
            anchor.target = '_blank'
            anchor.download = 'insurance_sample.csv'
            anchor.click()
        },
    },
}

export default app
</script>

<style lang="scss">
@mixin insuranceTableThMixin($column_counts, $column_colors) {
    $index: 2;
    @each $key, $count in $column_counts {
        @for $i from 0 through $count {
            &:nth-child(#{$i + $index}){
                background-color: map-get($column_colors, $key);
            }

        }
        $index: $index + $count;
    }
}

.shipping-table {
    .handsontable {
        $column_colors: (
            system: #fdfdfd,
            courier: #fdfdfd,
            system_updated_at: #111111,
            profile: #777777,
            from: #efefef,
            to: #d9ead3,
            importer: #9dead3,
            shipping: #d9d9d9,
        );
        $column_counts: (
            system: 4,
            courier: 2,
            system_updated_at: 1,
            profile: 0,
            from: 13,
            to: 13,
            importer: 13,
            shipping: 14,
        );
    
        &[mode="read"],
        &[mode="update"] {
            table {
                thead {
                    th {
                        $column_counts: map-merge($column_counts, (
                            system_updated_at: 0,
                            profile: 0,
                        ));
                        @include insuranceTableThMixin($column_counts, $column_colors);
                    }
                }
            }
        }
        &[mode="create"] {
            table {
                thead {
                    th {
                        $column_counts: map-merge($column_counts, (
                            system: 0,
                            system_updated_at: 0,
                            profile: 0,
                        ));
                        @include insuranceTableThMixin($column_counts, $column_colors);
                    }
                }
            }
        }
    
        &[mode="read"] {
            table {
                thead {
                    th {
                        i.required {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
</style>
